import type { LifeState } from './life.ts';
import { earn } from './life.ts';
import { homePrice } from './character.ts';

/**
 * Money bought with real money (a pack, paid on Paystack and checked by the server) going into this life's account.
 * Each payment's reference is kept in the life, so a pack the server offers again (the game crashed before telling it
 * the pack was in) is never paid twice. Returns what went in (0: already in).
 */
export function applyPack(s: LifeState, ref: string, credit: number, label: string): number {
  s.purchases ??= [];
  if (s.purchases.includes(ref)) return 0;
  const amount = homePrice(s, credit);
  s.purchases.push(ref);
  earn(s, amount, `Top-up: ${label}`);
  return amount;
}
